import { useState, useEffect } from "react";
import { getFinalPaymentMethods } from "utils/";
import { useGetTransactionMethods } from "api/transaction-methods";

const useGetPaymentMethods = ({ chooserConfig, params }) => {
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [isUpdated, setIsUpdated] = useState(false);
  const {
    data,
    isSuccess: isGetTransactionMethodsSuccess,
    ...rest
  } = useGetTransactionMethods(...params);

  useEffect(() => {
    if (isUpdated) {
      setIsUpdated(false);
    }
  }, [isUpdated, setIsUpdated]);

  useEffect(() => {
    if (isGetTransactionMethodsSuccess) {
      const pmsDict = data.payload.payment_methods;
      let paymentMethods = Object.keys(pmsDict).map((k) => pmsDict[k]);
      paymentMethods = getFinalPaymentMethods(paymentMethods, chooserConfig);

      // sort by last added pm to first added pm
      paymentMethods = paymentMethods.sort(
        (pm1, pm2) => new Date(pm2.created) - new Date(pm1.created)
      );

      paymentMethods = paymentMethods.map((paymentMethod) => {
        const isDefault = paymentMethod.tags.some(
          (tag) => tag.tag === "default_payment" && tag.status === "ACTIVE"
        );

        return { ...paymentMethod, isDefault };
      });

      setPaymentMethods(paymentMethods);
      setIsUpdated(true);
    }
  }, [isGetTransactionMethodsSuccess, data, chooserConfig]);

  return { paymentMethods, isUpdated, ...rest };
};

export default useGetPaymentMethods;
